export default __webpack_public_path__ + "static/dacha-record-6-9ecb4aa45cec7a9fd93ffa7d4721a7bb.png";